import { CSSProgressiveHeading02 } from "@caisy/league";
import styled from "styled-components";

export const SOnboardingTemplatesModalSiderTitle = styled.h2`
  ${CSSProgressiveHeading02}
`;
